import { Carousel, CarouselProps } from '../Carousel/Carousel';
import { useReviewCarousel } from './hooks/useReviewCarousel';
import { ReviewCard, ReviewCardReview } from './ReviewCard';

export interface ReviewCarouselProps {
    onSelectChange?: CarouselProps<ReviewCardReview>['onSelectChange'];
    onNextClick?: CarouselProps<ReviewCardReview>['onNextClick'];
    onPrevClick?: CarouselProps<ReviewCardReview>['onPrevClick'];
    onCardClick?: (id: string) => void;
}

export const ReviewCarousel = ({
    onCardClick,
    ...passThroughProps
}: ReviewCarouselProps): JSX.Element => {
    const { reviews } = useReviewCarousel();

    return (
        <Carousel
            render={(c: ReviewCardReview) => (
                <ReviewCard key={c.id} review={c} onCardClick={onCardClick} />
            )}
            content={reviews}
            {...passThroughProps}
        />
    );
};
